import React from "react";
import { useTranslation } from "react-i18next";
import { Bars3Icon } from "@heroicons/react/24/outline";
import Brand from "../Brand/Brand";

// Mobile-only top bar: on md+ the logo and profile live in the sidebar.
export default function Navbar({ menuOpen = false, onMenuClick }) {
  const [t] = useTranslation();
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-slate-200 bg-white px-3 md:hidden">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label={t("nav.open_menu")}
        aria-expanded={menuOpen}
        className="rounded-lg p-2 text-slate-500 transition duration-200 hover:bg-slate-100 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
      >
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>
      <Brand />
    </header>
  );
}
